import React from 'react';
import PropTypes from 'prop-types';
import api from '../../../Api';

const GeneralContext = React.createContext({});
const { Provider: GeneralProvider, Consumer: GeneralConsumer } = GeneralContext;

export const connectToGeneralStore = Component => {
	const WrappedComponent = props => {
		return (
			<GeneralConsumer>
				{generalState => {
					return <Component generalState={generalState} {...props} />;
				}}
			</GeneralConsumer>
		);
	};

	WrappedComponent.displayName = Component.displayName;

	return WrappedComponent;
};

export default class GeneralStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.arrayOf(PropTypes.element),
		]),
	};

	state = {
		communities: [],
		loading: true,
	};

	render() {
		const state = this.state;
		const props = this.props;

		return (
			<GeneralProvider value={state}>{props.children}</GeneralProvider>
		);
	}

	componentDidMount() {
		api.get('/api/affiliations/general').then(result =>
			this.setState({
				communities: result.communities,
				loading: false,
			}),
		);
	}
}
